import queryString from "qs";

/**
 * Creates a URL from a pathname and query parameters
 * @param pathname - The base pathname
 * @param query - Optional query parameters object
 * @returns The complete URL string
 */
export function createUrl(pathname: string, query: Record<string, any> = {}): string {
    // Check if query object is empty
    if (Object.keys(query).length === 0) {
        return pathname;
    }

    const queryStringified = queryString.stringify(query);
    return queryStringified ? `${pathname}?${queryStringified}` : pathname;
}

/**
 * Check if an object is empty (no own enumerable properties)
 * @param obj - Object to check
 * @returns True if the object is empty or nullish
 */
export function isEmpty(obj: Record<string, any> | null | undefined): boolean {
    if (obj == null) return true;
    return Object.keys(obj).length === 0;
}

/**
 * Check if an array is empty or nullish
 * @param arr - Array to check
 * @returns True if the array is empty or nullish
 */
export function isArrayEmpty<T>(arr: T[] | null | undefined): boolean {
    if (arr == null) return true;
    return arr.length === 0;
}
